/**
 * The two Tracey agents a user can pick between. Single source of truth for the
 * key ("sprint" | "ultra", sent to the backend as `version`), display name, and
 * the capabilities/description shown in the picker and empty-state hero so users
 * understand what each agent can do before choosing.
 */
export const TRACEY_AGENTS = [
  {
    key: 'ultra',
    name: 'Tracey Ultra',
    tagline: 'Deep strategic intelligence',
    accent: '#ff1463',
    speed: 'Thorough',
    cost: 'Higher cost',
    description:
      'Deep, strategic intelligence across contracts, budgets, policy and market data. ' +
      'Built for complex analysis, account planning, opportunity strategy and evidence-backed recommendations.',
    capabilities: [
      'PDF report generation',
      'Cluster management (suppliers & buyers)',
      'Create & run saved searches',
      'Budget & fiscal analysis',
      'Strategy vs procurement comparison',
      'Opportunity, expiry & forecast analysis',
      'Cross-comparison across Tendertrace tools',
    ],
    dataSources: [
      'Tendertrace contracts & tenders',
      'Federal Budget & MYEFO papers',
      'Portfolio Budget Statements & annual reports',
      'Corporate & strategic plans',
      'Commonwealth Procurement Rules (CPR / IPP)',
      'AIIA policy submissions & analysis',
      'Victorian Silver Review & State Budget',
    ],
    suggestedPrompts: [
      'Build an account brief on the Department of Health',
      'Which agencies got new cyber funding but haven’t gone to market yet?',
      'Compare Defence’s strategy to its actual procurement',
      'Generate a PDF opportunity report for NSW transport',
    ],
  },
  {
    key: 'sprint',
    name: 'Tracey Sprint',
    tagline: 'Fast procurement answers',
    accent: '#0891b2',
    speed: 'Fast',
    cost: 'Lower cost',
    description:
      'Fast, focused insights across contracts and procurement intelligence. Built for quick ' +
      'answers, contract lookups, supplier activity, buyer trends and immediate opportunity context.',
    capabilities: [
      'Fast tender & contract search',
      'Supplier & buyer activity',
      'Market & leaderboard insights',
      'Quick opportunity lookups',
    ],
    dataSources: [
      'Tendertrace contracts & tenders',
    ],
    suggestedPrompts: [
      'Show the top IT suppliers to NSW Health',
      'Find tenders over $1M closing this month',
      'Who won the most contracts in Victoria last quarter?',
      'Search recent cybersecurity tenders',
    ],
  },
];

export function agentByKey(key) {
  return TRACEY_AGENTS.find((a) => a.key === key) || TRACEY_AGENTS[0];
}
